import { c as _c } from "react/compiler-runtime";
import { Checkbox, PrimaryButton } from '@systemeio/ui';
import { useBlogCategories } from 'modules/blogs/hooks/use-blog-categories';
import { BlogCategoriesApiInterface } from 'modules/blogs/types/blog-categories-interface';
import React, { useEffect, useState } from 'react';
import { FieldErrorAndDescription, FieldErrorAndDescriptionProps } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
interface BlogCategoriesCheckboxProps extends FieldErrorAndDescriptionProps {
  selectedCategories: {
    id: number;
    name: string;
  }[];
  onChange: (data: {
    id: number;
    name: string;
  }[]) => void;
  blogId: string;
}
const BlogCategoriesCheckbox = t0 => {
  const $ = _c(38);
  const {
    selectedCategories,
    onChange,
    error,
    blogId
  } = t0;
  const {
    setPagination: setPaginationCategories,
    pagination: paginationCategories,
    limit
  } = usePagination(true);
  let t1;
  if ($[0] !== blogId || $[1] !== limit || $[2] !== paginationCategories) {
    t1 = {
      limit,
      pagination: paginationCategories,
      id: blogId
    };
    $[0] = blogId;
    $[1] = limit;
    $[2] = paginationCategories;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    blogCategories
  } = useBlogCategories(t1);
  const {
    t
  } = useLocoTranslation();
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hasMore: false,
      items: []
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [tempState, setTempState] = useState(t2);
  let t3;
  let t4;
  if ($[5] !== blogCategories) {
    t3 = () => {
      if (blogCategories) {
        setTempState(prev => {
          const uniqIds = prev.items.map(_temp);
          const uniqCategories = blogCategories.items.filter(el_0 => !uniqIds.includes(el_0.id));
          return {
            hasMore: blogCategories.hasMore,
            items: [...prev.items, ...uniqCategories]
          };
        });
      }
    };
    t4 = [blogCategories];
    $[5] = blogCategories;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[8] !== blogCategories || $[9] !== onChange || $[10] !== selectedCategories || $[11] !== t || $[12] !== tempState.items) {
    const valueIds = selectedCategories.map(_temp2);
    t7 = `flex-col gap-1 text-sm font-medium ${blogCategories && tempState?.items.length === 0 ? "hidden" : "flex"}`;
    let t9;
    if ($[17] !== t) {
      t9 = t("dashboard.blog.categories.title_plural");
      $[17] = t;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    if ($[19] !== t9) {
      t8 = <span>{t9}</span>;
      $[19] = t9;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t5 = "flex flex-row flex-wrap gap-5";
    t6 = !blogCategories && tempState?.items.length === 0 ? <BlogCategoriesCheckboxSkeleton /> : tempState.items.map(el_2 => {
      const isSelected = valueIds.includes(el_2.id);
      return <li key={el_2.id}><Checkbox value={isSelected} label={el_2.name} onChange={() => isSelected ? onChange(selectedCategories.filter(category => category.id !== el_2.id)) : onChange([...selectedCategories, el_2])} /></li>;
    });
    $[8] = blogCategories;
    $[9] = onChange;
    $[10] = selectedCategories;
    $[11] = t;
    $[12] = tempState.items;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t6) {
    t9 = <ul className={t5}>{t6}</ul>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== blogCategories || $[25] !== setPaginationCategories || $[26] !== t || $[27] !== tempState.hasMore || $[28] !== tempState.items) {
    t10 = tempState.hasMore && <PrimaryButton type="button" isFetching={!blogCategories} onClick={() => setPaginationCategories(prev_0 => ({
      ...prev_0,
      startFromId: tempState.items[tempState.items.length - 1].id
    }))}>{t("dashboard.blog.categories.load_more")}</PrimaryButton>;
    $[24] = blogCategories;
    $[25] = setPaginationCategories;
    $[26] = t;
    $[27] = tempState.hasMore;
    $[28] = tempState.items;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== error) {
    t11 = <FieldErrorAndDescription error={error} />;
    $[30] = error;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t12 = <div className={t7}>{t8}{t9}{t10}{t11}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
};
const BlogCategoriesCheckboxSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse gap-7"><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BlogCategoriesCheckbox;
function _temp(el) {
  return el.id;
}
function _temp2(el_1) {
  return el_1.id;
}